/* Élan Vivre — Liquid Gold scroll reveal. Skipped for reduced motion and inside the theme editor. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;
  var sel = '.evg-prod__head,.evg-card,.evg-conc__h2,.evg-conc__item,.evg-scan__box,.evg-scan__step,.ev-ing-head,.ev-ing-card,.ev-ctab-wrap,.evg-rev__head,.evg-rev__card,.evg-rit__media,.evg-rit__copy,.evg-colhero__copy,.related-products__heading,.related-products .grid__item,.product-grid .grid__item,.evp-h2,.evp-left,.evp-card,.evp-step,.ev-ifs-item,.ev-cc-h2,.ev-cc-card,.ev-best__head,.ev-best__card,.ev-sks-dark,.ev-sks-step,.ev-nl-h2';
  function init() {
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ev-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    [].slice.call(document.querySelectorAll(sel)).forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.9) return; /* already on screen: no flash */
      var i = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--ev-d', (Math.min(i, 5) * 90) + 'ms');
      el.classList.add('ev-reveal');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
